import React from 'react';
import {
  Form, Row, Col, Button, message
} from 'antd';
import FileBase64 from 'react-file-base64';
import img from './../../assets/img/Illustration.png';
class FD extends React.Component {
constructor(props){
super(props)
this.state={
}
}
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if(this.fileData){
          if (this.fileData.file.size > 2097152) {
            message.warning("File size must under 2MiB!",5);
          }else if(this.fileData.name.split('.')[1]!=='pdf')
          {
            message.error("Invalid file format!, Plese upload PDF file.",10)
          }
          else{
          this.props.submitHandler({ ...values, file: this.fileData.base64, name: this.fileData.name },(val)=>{
            if(!val){
            }
          });
          }
        }else{
          message.error("Plese upload PDF file.",10)
        }
      }
    });
  }
  handleAddDocument = (data) => {
      if (data.file.size > 2097152)
            {
              message.warning("File size must under 2MiB!",5);
            }
            if(data.name.split('.')[1]!=='pdf')
            {
              message.error("Invalid file format!, Plese upload PDF file.",10)
            }
              this.fileData = data;
  }
  render() {    
    return (
      <div className="mi_model_popup">
        <Row span={24}>
          <Col span={18}>
            <p className='mi_title'>{this.props.title}</p>
          </Col>
          <Col span={6}>
            <i className="fa fa-times mi_icon mi_icon_red mi_button_close" style={{ color: 'red' }} onClick={this.props.closeDrawerHandler} ></i>
          </Col>
        </Row>
        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
         
         
          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Document File</legend>
                  <FileBase64 onDone={this.handleAddDocument} />
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
            </Col>
          </Row>
          <Row span={24} style={{ marginTop: '20px' }}>
            <Col span={7}></Col>
            <Col span={5}>
              <Button className="mi_button_right" onClick={this.props.closeDrawerHandler} style={{ marginRight: 8 }}>
                Cancel
                      </Button>
            </Col>
            <Col span={5}>
              <Button htmlType="submit" type="primary" >
                Submit
                  </Button>
            </Col>
            <Col span={7}>
              <img alt="example" style={{ width: 105, marginBottom: '-20px', float: 'right' }} src={img} />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}
const AddDocumentDrawer = Form.create()(FD);
export default AddDocumentDrawer;